import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import MediaCard from "@/components/feature/MediaCard";
import SectionHeading from "@/components/feature/SectionHeading";
import HeroCarousel from "./components/HeroCarousel";
import CategoryShortcuts from "./components/CategoryShortcuts";
import NewsPanel from "./components/NewsPanel";
import SidebarRecommend from "./components/SidebarRecommend";
import { movies } from "@/mocks/movies";
import { tvShows } from "@/mocks/tvshows";
import { allMedia } from "@/utils/media";
import { useSeo } from "@/hooks/useSeo";
import { Link } from "react-router-dom";

export default function Home() {
  useSeo({
    title: "飘花电影网—最新电影电视剧在线播放及资讯",
    description:
      "飘花电影网提供丰富的电影、电视剧资源和最新影视资讯，涵盖多类型影视作品，方便用户在线观看和了解影视动态。",
    keywords: "飘花电影网,电影,电视剧,影视资讯,在线电影,影视资源,影视动态",
  });

  const featured = [...allMedia].sort((a, b) => b.heat - a.heat).slice(0, 5);
  const hotMovies = [...movies].sort((a, b) => b.heat - a.heat).slice(0, 6);
  const hotTv = [...tvShows].sort((a, b) => b.heat - a.heat).slice(0, 6);

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <SiteHeader />

      <main className="mx-auto w-full max-w-[1200px] flex-1 px-4 py-6 md:px-6">
        <div className="mb-6 animate-fade-up">
          <HeroCarousel items={featured} />
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="space-y-6 lg:col-span-2">
            <CategoryShortcuts />
            <NewsPanel />
          </div>
          <aside className="lg:col-span-1">
            <SidebarRecommend />
          </aside>
        </div>

        <section className="mt-10">
          <SectionHeading title="热门电影推荐" icon="ri-movie-2-line" morePath="/movie" moreLabel="更多电影" />
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
            {hotMovies.map((item) => (
              <MediaCard key={item.id} media={item} compact />
            ))}
          </div>
        </section>

        <section className="mt-10">
          <SectionHeading title="热播电视剧推荐" icon="ri-tv-2-line" morePath="/tv" moreLabel="更多剧集" />
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
            {hotTv.map((item) => (
              <MediaCard key={item.id} media={item} compact />
            ))}
          </div>
        </section>

        <section className="mt-10 rounded-xl border border-background-200 bg-background-50 p-6 text-center md:p-8">
          <h2 className="font-heading text-xl font-bold text-foreground-900">关于飘花电影网</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            飘花电影网专注于为影视爱好者提供最新电影、电视剧的分类浏览与详细介绍，并汇聚影视新闻、专题报道与影评内容，
            帮助用户便捷地发现优质作品、掌握行业动态。本站内容为演示展示，欢迎通过搜索快速找到感兴趣的内容。
          </p>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/movie"
              className="whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              浏览电影
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              了解我们
            </Link>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}